module.exports = __webpack_public_path__ + "img/bg-lover.3d894ea7.webp";